import * as colors from '../../shared/colors.json';
import { Injectable } from 'ng-metadata/core';

/**
 * @ngdoc service
 * @name mwColorsService
 * @module mw.components.colors
 *
 * @description
 * EXPERIMENTAL:
 * The `mwColorsService` provides an api for retrieving Meltwater defined colors.
 *
 * Internally, the service retrieves color values from <a href="https://github.com/meltwater/gaf-ng-components/blob/master/src/lib/shared/colors.json">colors.json</a>.
 *
 * @usage
 * <hljs hljs-language="js">
 * app.controller('MyController', function(mwColorsService) {
 *   this.twitterBlue = mwColorsService.fromVar('blueTwitter'); // returns '#55acee'
 *   this.basicChartColors = mwColorsService.fromCategory('Chart - Basic'); // returns an array containing all the color object values from the specified category
 * });
 * </hljs>
 */
/**
 * @ngdoc method
 * @name mwColorsService#fromVar
 * @param {String} varName The name of a Meltwater defined color variable.
 *
 * @returns {String} hex color value
 *
 */
/**
 * @ngdoc method
 * @name mwColorsService#fromCategory
 * @param {String} catName The name of a Meltwater defined color category.
 *
 * @returns {array} array of color value objects
 *
 */
@Injectable()
export class ColorsService {

    private varCharsRegexp = /[@|_]/g;
    private hexColorRegexp = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;

    constructor() {
    }

    fromVar(varName: string) {
        let color;

        for (let i = 0; i < colors.length; i++) {
            const category = colors[i];
            color = category.colors.find(color => varName === this.cleanVarName(color.var));
            if (color) break;
        }

        if (color) {
            return color.hex;
        }

        return color;
    }

    fromCategory(catName: string) {
        let _colors;

        for (let i = 0; i < colors.length; i++) {
            const category = colors[i];
            if (category.category.toLowerCase() === catName.toLowerCase()) {
                _colors = [].concat(category.colors) // create a copy of the array
                    .map(color => color.var = this.cleanVarName(color.var)); // return cleaned var list
                break;
            }
        }

        return _colors;
    }

    isHexColor(colorToTest: string) {
        return this.hexColorRegexp.test(colorToTest)
    }

    cleanVarName(varName: string) {
        return varName.replace(this.varCharsRegexp, '');
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/colors/colors.service.ts